module.exports = __webpack_public_path__ + "fonts/LiberationSans-Bold.57eb9d52.ttf";